import React, { useEffect, useState } from 'react'
import FunnelIcon from '../icons/FunnelIcon'
import CloseIcon from '../icons/CloseIcon'
import PlusIcon from '../icons/PlusIcon'
import { debounce, parseNigerianStates, unSlugify } from '../../../utils'
import { Nationalities } from '../../../assets/static/nationalities'
import { useDispatch, useSelector } from 'react-redux'
import { fetchClasses } from '../../../store/actions/classesDivisionsActions'
import { authHeader, baseUrl } from "../../../utils"
import { ADMISSIONS_ERROR, PARENTS_ERROR } from '../../../store/types'
import axios from 'axios'
import InlinePreloader from '../InlinePreloader'

const StudentsFilters = ({applyFilters, filtersToHide=[]}) => {
    const dispatch = useDispatch()
    const classesSelector = useSelector(state => state.classes)

    
    useEffect(() => {
        dispatch(fetchClasses())
        return () => {
            
        };
    }, [dispatch]);
    const filters = [
        {
            name: 'marketplace',
            linkType: 'text',
            link: 'is',
            type: 'binary',
            options: ['Primary', 'Secondary'],
            value: "",
            displayValue: ""
        },
        {
            name: 'Tribe',
            filterValue: 'tribe',
            linkType: 'text',
            link: 'is',
            type: 'free-text',
            options: [],
            value: "",
            displayValue: "",
            hide: filtersToHide.includes('tribe')
        },
        {
            name: 'Spoken language',
            filterValue: 'languages',
            linkType: 'text',
            link: 'is',
            type: 'free-text',
            options: [],
            value: "",
            displayValue: "",
            hide: filtersToHide.includes('languages')
        },
        {
            name: 'Nationality',
            filterValue: 'nationality',
            linkType: 'text',
            link: 'is',
            type: 'binary',
            options: Nationalities.map(nationality => {return nationality.name}),
            value: "",
            displayValue: "",
            hide: filtersToHide.includes('nationality')
        },
        {
            name: 'State of Origin',
            filterValue: 'state',
            linkType: 'text',
            link: 'is',
            type: 'binary',
            options: parseNigerianStates().map(state => {return state.label}),
            value: "",
            displayValue: "",
            hide: filtersToHide.includes('state')
        },
        {
            name: 'Gender',
            filterValue: 'gender',
            linkType: 'text',
            link: 'is',
            type: 'binary',
            options: ['FEMALE', 'MALE'],
            value: "",
            displayValue: "",
            hide: filtersToHide.includes('gender')
        },
        {
            name: 'Religion',
            filterValue: 'religion',
            linkType: 'text',
            link: 'is',
            type: 'binary',
            options: ['CHRISTIANITY', 'ISLAM', 'OTHER'],
            value: "",
            displayValue: "",
            hide: filtersToHide.includes('religion')
        },
        {
            name: 'Previous school',
            filterValue: 'schoolsAttended',
            linkType: 'text',
            link: 'is',
            type: 'free-text',
            options: [],
            value: "",
            displayValue: "",
            hide: filtersToHide.includes('schoolsAttended')
        },
        {
            name: 'Status',
            filterValue: 'status',
            linkType: 'text',
            link: 'is',
            type: 'binary',
            options: ["ACTIVE", "SUSPENDED", "EXPELLED", "PROBATION"],
            value: "",
            displayValue: "",
            hide: filtersToHide.includes('status')
        },
        {
            name: 'Opening Admitted',
            filterValue: 'admission',
            linkType: 'text',
            link: 'is',
            type: 'search',
            options: [],
            value: "_id",
            displayValue: "title",
            ref: "opening",
            hide: filtersToHide.includes('admission')
        },
        {
            name: 'Current Class',
            filterValue: 'currentClass',
            linkType: 'text',
            link: 'is',
            type: 'binary',
            options: classesSelector?.classes?.classes?.length > 0 ? [...classesSelector.classes.classes].sort((a, b) => b.order - a.order) : [],
            value: "_id",
            ref: "class",
            displayValue: "name",
            hide: filtersToHide.includes('studentClass')
        },
        {
          name: 'Parent',
          filterValue: 'parent',
          linkType: 'text',
          link: 'is',
          type: 'search',
          options: [],
          ref: 'parent',
          value: "_id",
          displayValue: "fullName",
          hide: filtersToHide.includes('parent')
        },
        // {
        //   name: 'Sibling in VCM',
        //   linkType: 'text',
        //   link: 'is',
        //   type: 'search',
        //   options: [],
        //   value: "",
        //   displayValue: ""
        // },
        {
          name: 'Date of Birth',
          filterValue: 'dob',
          linkType: 'option',
          link: ['is after', 'is before'],
          type: 'date',
          value: "",
          displayValue: ""
        },
        {
          name: 'date admitted',
          filterValue: 'createdAt',
          linkType: 'option',
          link: ['is after', 'is before'],
          type: 'date',
          value: "",
          displayValue: ""
        }
    ]
    const filterOptions = filters.filter(fil => !fil.hide)

    const clearFilters = () => {
        setActiveFilters([])
        applyFilters('')

    }

    const [ activeFilters, setActiveFilters ] = useState([])
    
    const [ selectingFilters, setSelectingFilters ] = useState(false)
    
    const [ activeFilterOption, setActiveFilterOption ] = useState(null)

    const [ filterLinkOption, setFilterLinkOption ] = useState(null)
    const [ filterValue, setFilterValue ] = useState(null)

    // const FilterDisplay = ({filterName, filterLink, filterValue}) => {
    //     return (
    //         <p className='text-sm'> <span className='font-medium'>{filterName}</span> {filterLink} <span className='font-medium'>{filterValue}</span> </p>
    //     )
    // }

    const addFilter = (index) => {
        if(!filterValue || filterValue === '') {
            console.log('condition 1 unmet')
            return
        }

        if(filterOptions[index].linkType === 'option' && (!filterLinkOption || filterLinkOption === '')) {
            console.log('condition 2 unmet')
            return
        }

        const tempActiveFilters = JSON.parse(JSON.stringify(activeFilters))

        let filterLink = 'is'
        if(filterOptions[index].linkType === 'option') {
            filterLink = filterLinkOption
        }
        
        // const filterText = 
        const currentFilter = JSON.parse(JSON.stringify(filterOptions[index]))
        currentFilter.selectedValue = filterValue

        let filterDisplayValue = ''
        if(filterOptions[index].ref === 'class') {
            const selectedClass = classesSelector?.classes?.classes?.find(cls => cls[filterOptions[index].value] === filterValue)
            filterDisplayValue = selectedClass?.[filterOptions[index].displayValue] || ''
        }
        if(filterOptions[index].ref === 'parent' || filterOptions[index].ref === 'opening') {
            filterDisplayValue = selectedSearchResult[filterOptions[index].displayValue]
        }

        currentFilter.displayValue = `${filterOptions[index].name} ${filterLink} ${filterDisplayValue === '' ? filterValue : filterDisplayValue}`

        tempActiveFilters.push(currentFilter)
        setActiveFilters(tempActiveFilters)
        setFilterLinkOption(null)
        setActiveFilterOption(null)
        setFilterValue(null)
        setSelectingFilters(false)
        setSelectedSearchResult(null)
        applyFilters(parseFiltersToString(tempActiveFilters))
    }

    const parseFiltersToString = (filtersArray) => {
        let simplifiedArray = []
        filtersArray.forEach(filter => {
            simplifiedArray.push(`${filter.filterValue}=${filter.selectedValue}`)
        })

        return simplifiedArray.join('&')
    } 
    
    const removeFilter = (filter) => {
        const newFilters = activeFilters.filter((item) => {
            return filter !== item 
        })
        setActiveFilters(newFilters)
        applyFilters(parseFiltersToString(newFilters))
    }

    const [searching, setSearching] = useState(false);
    const [searchResults, setSearchResults] = useState([]);
    const [selectedSearchResult, setSelectedSearchResult] = useState(null);

    const searchForOpening = async (term) => {
        try{
            const headers = authHeader()
            let url = `${baseUrl}/admissions?expand=academicSession,fee&title=${term}`
            setSearching(true)
            const response = await axios.get(url, { headers })
            setSearchResults(response.data.data.admissions)
            setSearching(false)
        }
        catch(error){
            dispatch( {
                type: ADMISSIONS_ERROR,
                error
            })
            setSearching(false)
            setSearchResults([])
        }
    }

    const searchForParent = async (term) => {
        try{
            const headers = authHeader()
            let url = `${baseUrl}/parents?expand=userProfile&page=0&perPage=0&name=${term}&email=${term}&phone=${term}`
            setSearching(true)
            const response = await axios.get(url, { headers })
            setSearchResults(response.data.data.parents)
            setSearching(false)
        }
        catch(error){
            dispatch( {
                type: PARENTS_ERROR,
                error
            })
            setSearching(false)
            setSearchResults([])
        }
    }

    const performSearch = debounce((term, optionIndex) => {
        if(filterOptions[optionIndex].ref === 'parent') {
            searchForParent(term)
        }  
        if(filterOptions[optionIndex].ref === 'opening') {
            searchForOpening(term)
        }  
    })
    
    return (
        <div className="flex flex-row gap-2 flex-wrap">
            <span className={`py-2 px-3 rounded-md text-gray-600 font-outfit text-sm flex items-center justify-center gap-x-1 ${activeFilters && activeFilters.length > 0 ? 'bg-vcm-light-purple bg-opacity-20' : 'bg-gray-100'}`}> 
                <FunnelIcon className="w-4 h-4 inline" /> Filters
            </span>

            { activeFilters.map((filter, filterIndex) => (
                <span 
                    className='py-2 px-2 capitalize rounded-md bg-gray-100 text-gray-600 flex gap-x-3 items-center text-xs font-outfit' 
                    key={filterIndex}
                > 
                    {unSlugify(filter.displayValue.toLowerCase())}
                    
                    <button onClick={()=>{removeFilter(filter)}}>
                        <CloseIcon className="w-4 h-4" />
                    </button>
                </span>
            ))}
            {activeFilters.length > 1 && <button onClick={()=>{clearFilters()}} className='bg-gray-100 text-gray-600 px-3 py-2 rounded'>
                <CloseIcon className="w-4 h-4" />
            </button>}

            <div className='relative'>
                <button className='p-3 rounded-md bg-gray-100 text-gray-600 transition duration-200 hover:bg-gray-200' onClick={()=>{setSelectingFilters(!selectingFilters)}}>
                    <PlusIcon className={`w-5 h-5 transition duration-200 ${selectingFilters && 'rotate-45'}`} />
                </button>
                <div className={`z-50 bg-white rounded-md shadow-lg p-2 w-[250px] absolute top-0 left-14 ${ selectingFilters ? 'inline-block' : 'hidden' }`}>
                    <div className='relative'>
                        {filterOptions.map(( option, optionIndex ) => (
                            optionIndex !== 0 &&
                            <button 
                                key={optionIndex} 
                                className={`capitalize text-sm text-left my-1 p-2 hover:bg-gray-100 rounded-sm transition duration-200 text-gray-600 w-full block ${optionIndex === activeFilterOption ? 'bg-gray-100' : ''}`} 
                                onClick={()=>{
                                    setSearchResults([])
                                    setActiveFilterOption(optionIndex)
                                }}
                            >
                                {option.name}
                            </button>
                        ))}
                        {activeFilterOption && activeFilterOption !== 0 && 
                            <div className='absolute top-0 left-[250px] w-[250px] rounded-sm p-5 bg-white shadow-lg'>
                                <p className="text-sm font-outfit text-gray-600 mb-2 rounded-sm capitalize">{filterOptions[activeFilterOption].name}</p>
                                {filterOptions[activeFilterOption].linkType === 'text' && <p className="text-sm text-gray-600">{filterOptions[activeFilterOption].link}</p>}
                                {filterOptions[activeFilterOption].linkType === 'option' && 
                                    <select className="text-sm text-gray-600 p-1 border rounded-sm w-full my-2 outline-none" onChange={(e)=>{setFilterLinkOption(e.target.value)}}>
                                        <option value="">-- select one --</option>
                                        {filterOptions[activeFilterOption].link.map((linkOption, linkOptionIndex)=>(
                                            <option key={linkOptionIndex} value={linkOption}>{unSlugify(linkOption.toLowerCase())}</option>
                                        ))}
                                    </select>
                                }
                                {filterOptions[activeFilterOption].type === 'binary' && 
                                <>
                                    {(!filterOptions[activeFilterOption].displayValue || filterOptions[activeFilterOption].displayValue === '') ?
                                        <select className="text-sm text-gray-600 p-1 border rounded-sm w-full my-2 outline-none capitalize" onChange={(e)=>{setFilterValue(e.target.value)}}>
                                            <option value="">-- select one --</option>
                                            {filterOptions[activeFilterOption].options.map((option, optionIndex)=>(
                                                <option key={optionIndex} value={option}>{unSlugify(option.toLowerCase())}</option>
                                            ))}
                                        </select>
                                        :
                                        <select className="text-sm text-gray-600 p-1 border rounded-sm w-full my-2 outline-none capitalize" onChange={(e)=>{setFilterValue(e.target.value)}}>
                                            <option value="">-- select one --</option>
                                            {filterOptions[activeFilterOption].options.map((option, optionIndex)=>(
                                                <option key={optionIndex} value={option[filterOptions[activeFilterOption].value]}>
                                                    {option[filterOptions[activeFilterOption].displayValue]}
                                                </option>
                                            ))}
                                        </select>
                                    }
                                </>
                                }

                                {filterOptions[activeFilterOption].type === 'number' && 
                                    <input placeholder='value' type='number' className="text-sm text-gray-600 p-1 border rounded-sm w-full my-2 outline-none"  onChange={(e)=>{setFilterValue(e.target.value)}} />
                                }

                                {filterOptions[activeFilterOption].type === 'date' && 
                                    <input placeholder='value' type='date' className="text-sm text-gray-600 p-1 border rounded-sm w-full my-2 outline-none"  onChange={(e)=>{setFilterValue(e.target.value)}} />
                                }

                                {filterOptions[activeFilterOption].type === 'free-text' && 
                                    <input placeholder='value' type="text" className="text-sm text-gray-600 p-1 border rounded-sm w-full my-2 outline-none"  onChange={(e)=>{setFilterValue(e.target.value)}} />
                                }

                                {filterOptions[activeFilterOption].type === 'search' && 
                                <div className='w-full'>
                                    <input placeholder='search' onChange={(e)=>{performSearch(e.target.value, activeFilterOption )}} type="text" className="text-sm text-gray-600 p-1 border rounded-sm w-full my-2 outline-none" />

                                    {searching 
                                        ? 
                                        <div className='mx-auto py-[10px]'>
                                            <InlinePreloader /> 
                                        </div>
                                        : 
                                        searchResults?.length > 0 && 
                                        <div className='w-full'>
                                            {searchResults.map((result, resultIndex) => (
                                                <button 
                                                    key={resultIndex}
                                                    onClick={()=>{
                                                        setFilterValue(result[filterOptions[activeFilterOption]?.value])
                                                        setSelectedSearchResult(result)
                                                    }} 
                                                    className={`w-full p-[5px] text-xs text-left mb-[5px] hover:bg-gray-50 rounded 
                                                        ${selectedSearchResult && selectedSearchResult[filterOptions[activeFilterOption]?.value] === result[filterOptions[activeFilterOption]?.value] ? 'bg-gray-200' : 'bg-transparent'}
                                                    `}
                                                >
                                                    {result[filterOptions[activeFilterOption].displayValue]}
                                                </button>
                                            ))}
                                        </div>
                                    }
                                </div>
                                }

                                <button 
                                    className='w-full p-1 rounded-sm text-white text-sm bg-gray-600 my-3 transition duration-200 hover:bg-gray-800' 
                                    onClick={()=>{addFilter(activeFilterOption)}}>
                                        Add Filter
                                </button>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}
export default StudentsFilters